import React from 'react';
import { Linkedin, Instagram, Map, LocateIcon, MapPin } from 'lucide-react';
import logo from '../assets/logo.png';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="bg-white border-t border-gray-200 text-gray-800 py-6 px-4 sm:px-6 lg:px-8">
            <div className="max-w-7xl mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
                    {/* Brand + Social */}
                    <div className="col-span-1 md:col-span-2">
                        <div className="flex items-center space-x-2 mb-4">
                            <img src={logo} alt="OneHexa Logo" className="w-auto h-8" />
                        </div>
                        <p className="text-gray-600 mb-6 max-w-md">
                            Transforming businesses through{" "}
                            <span className="text-green-500 font-semibold">
                                innovative technology solutions
                            </span>
                            . We're your partners in digital excellence.
                        </p>

                        {/* Location Section */}
                        <div className="flex items-center text-gray-600 mb-6">
                            <MapPin className="w-5 h-5 mr-2 text-gray-600" />
                            <p>Office No. 9, Noor Plaza, NH-27, Wankaner, Morbi, Gujarat 363621</p>
                        </div>


                        {/* Social Icons */}
                        <div className="flex space-x-4">
                            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"
                                className="w-10 h-10 bg-gray-100 hover:bg-green-500 hover:text-white text-gray-600 rounded-full flex items-center justify-center transition-all cursor-pointer transform hover:scale-110 duration-300">
                                <Linkedin className="w-5 h-5" />
                            </a>
                            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer"
                                className="w-10 h-10 bg-gray-100 hover:bg-green-500 hover:text-white text-gray-600 rounded-full flex items-center justify-center transition-all cursor-pointer transform hover:scale-110 duration-300">
                                <Instagram className="w-5 h-5" />
                            </a>
                        </div>
                    </div>

                    {/* Services */}
                    <div>
                        <h3 className="text-lg font-semibold mb-4 text-gray-800">Services</h3>
                        <ul className="space-y-2 text-gray-600">
                            <li>
                                <Link to="/web-development" className="hover:text-green-500 transition-colors">
                                    Web Development
                                </Link>
                            </li>
                            <li>
                                <Link to="/mobile-apps" className="hover:text-green-500 transition-colors">
                                    Mobile Apps
                                </Link>
                            </li>
                            <li>
                                <Link to="/ecommerce" className="hover:text-green-500 transition-colors">
                                    E-Commerce
                                </Link>
                            </li>
                            <li>
                                <Link to="/digital-marketing" className="hover:text-green-500 transition-colors">
                                    Digital Marketing
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Company */}
                    <div>
                        <h3 className="text-lg font-semibold mb-4 text-gray-800">Company</h3>
                        <ul className="space-y-2 text-gray-600">
                            <li><Link to="/home" className="hover:text-green-500 transition-colors">Home</Link></li>
                            <li><Link to="/about" className="hover:text-green-500 transition-colors">About</Link></li>
                            <li><Link to="/products" className="hover:text-green-500 transition-colors">Products</Link></li>
                            <li><Link to="/contact" className="hover:text-green-500 transition-colors">Contact</Link></li>
                        </ul>
                    </div>
                </div>

                {/* Footer Bottom */}
                <div className="border-t border-gray-200 pt-5 text-center">
                    <p className="text-gray-600">
                        © {new Date().getFullYear()} OneHexa Tech. All rights reserved. |{" "}
                        <span className="text-green-500 font-semibold">
                            Building the future, one line of code at a time.
                        </span>
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
